<template>
  <div>
    <section
      v-if="subscribed && account.is_early_supporter"
      class="hero is-small is-light"
    >
      <div class="hero-body py-1">
        <div class="container has-text-centered">
          <h2 class=" is-6 my-1  has-text-info has-text-centered">
            🙏 Thanks for being an early supporter 🙏 
            🍕 You are awesome! 🍕
          </h2>
        </div>
      </div>
    </section>

    <template v-if="newsletterChart">
    <section class="section">
      <div class="container" >
          <h1 class="title">Newsletter Dashboard                   
            <b-tooltip
                    label="Dashboard stats for newsletter surveys."
                    multilined
                    position="is-right">
                   <b-icon
                icon="info"
                size="is-small"
                class="is-size-6">
            </b-icon>
            </b-tooltip></h1>
        <template v-if="hasStats">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <StatsCard
                title="All Time"
                :stats="stats.all_time_totals"
                :labels="statsLabels"
              />
            </div>
            <div class="tile is-parent">
              <StatsCard
                :title="'This Month'"
                :stats="stats.current_month_totals"
                :labels="statsLabels"
              />
            </div>
            <div class="tile is-parent">
              <StatsCard
                :title="'Last Month'"
                :stats="stats.previous_month_totals"
                :labels="statsLabels"
              />
            </div>
          </div>
          <div v-if="stats && stats.weekday_stats" class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="subtitle">Most {{statsLabels.votesUp}} on</p>
                <p class="title">{{ dayMostUpVotes }}</p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="subtitle">Most {{statsLabels.votesOk}} on</p>
                <p class="title">{{ dayMostOkVotes }}</p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="subtitle">Most {{statsLabels.votesDown}} on</p>
                <p class="title">{{ dayMostDownVotes }}</p>
              </article>
            </div>
          </div>


        <div v-if="newsletterChart" class="tile is-ancestor">
          <div class="tile is-parent maxw-100">
            <div class="tile is-child box chart maxw-100">
              <h2 class="subtitle">Recent Newsletter Performance <span v-bind:class="{'has-text-primary': !showNewsletterPerformanceChart}" class="icon is-small is-pulled-right is-clickable" @click="showNewsletterPerformanceChart =false"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-table"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path></svg></span><span v-bind:class="{'has-text-primary': showNewsletterPerformanceChart}" class="icon is-small is-pulled-right is-clickable" @click="showNewsletterPerformanceChart =true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart"><line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line></svg></span></h2>
              <chartist v-if="showNewsletterPerformanceChart" type="Bar" ratio="ct-chart" :data="newsletterChart" :options="chartOptions"></chartist>
              <div  v-else class="table-container">
                <table class="table is-fullwidth has-background-light">
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="header in newsletterPerformanceTable.headers" :key="'h' + header">{{ header }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in newsletterPerformanceTable.rows" :key="'r' + row">
                    <td v-for="cell, i in row" :key="row +'c' + i">{{ cell }}</td>
                  </tr>
                </tbody>
              </table>
              </div>
              <p class="has-text-centered mb-5">
                <a v-if="account.has_pro_features" class="button is-outlined is-primary" @click.prevent="exportPerformanceReport">Export as CSV</a>
                <span v-else class="button is-outlined is-primary">Export as CSV</span>
                      <span
                        v-if="!account.has_pro_features"
                        class="ml-3 tag is-success"
                        >PRO</span
                      >
                      <router-link
                        v-if="!account.has_pro_features"
                        :to="{ name: 'Upgrade' }"
                        class="tag is-info"
                        >Unlock Now</router-link
                      >
              </p>
            </div>
          </div>
        </div>
        </template>
            <template v-else>
<section class="hero is-small">
  <div class="hero-body">

<p class="has-text-centered">
    <span class="icon is-large is-size-1 has-text-grey		">
      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-coffee"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>
    </span>
</p>
<p class="has-text-centered mt-3">
  Nothing to report yet. Please share your newsletter survey and come back later.
</p>


  </div>
</section>
    </template>
      </div>
    </section>
    </template>
    <template v-if="recentFeedback">
    <section class="section">
      <div class="container" ref="recentFeedbackLoading">
        <h2 class="subtitle has-text-centered mb-2">
          Recent Extended Feedback ({{recentFeedbackLimit}})
          <div class="dropdown is-hoverable">
          <div class="dropdown-trigger">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              aria-controls="dropdown-menuRFL"
            ></b-icon>
          </div>
          <div class="dropdown-menu" id="dropdown-menuRFL" role="menu">
            <div class="dropdown-content has-text-left">
              <a class="dropdown-item" @click.prevent="loadRecentFeedback(50)">
                Show 50
              </a>
              <a class="dropdown-item" @click.prevent="loadRecentFeedback(100)">
                Show 100
              </a>
              <a class="dropdown-item" @click.prevent="loadRecentFeedback(500)">
                Show 500
              </a>   
            </div>
          </div>
        </div>
        </h2>
        <p class="has-text-centered mb-5">
          <a v-if="account.has_pro_features" class="button is-outlined is-primary" @click.prevent="exportFeedback">Export All Feedback as CSV</a>
          <span v-else class="button is-outlined is-primary">Export All Feedback as CSV</span>
                <span
                  v-if="!account.has_pro_features"
                  class="ml-3 tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
        </p>
        <p v-if="recentFeedback.length === 0" class="has-text-centered">
          No extended feedback reported by your readers.
        </p>

        <div class="columns is-multiline">
          <div
            class="column is-4-desktop is-6-tablet"
            v-for="r in recentFeedback"
            v-bind:key="r.id"
          >
            <FeedbackReasonCard :reason="r" :subscribed="subscribed" :user="user" v-on:feedback-deleted="feedbackDeleted"/>
          </div>
        </div>
      </div>
    </section>

    </template>
    <template v-if="!isLoading && !newsletterChart">
<section class="hero is-large">
  <div class="hero-body">

<p class="has-text-centered">
    <span class="icon is-large is-size-1 has-text-grey		">
      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-coffee"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>
    </span>
</p>
<p class="has-text-centered mt-3">
  Yay, the smell of something new.
</p>

<p class="has-text-centered mt-3">
    <router-link
    :to="{ name: 'FeedbackCreate' }"
    >Create your first newsletter survey now.</router-link
  >
</p>

  </div>
</section>
    </template>

    
  </div>
</template>

<script>
// @ is an alias to /src
import atomic from "atomicjs";
import StatsCard from "@/components/StatsCard.vue";
import FeedbackReasonCard from "@/components/FeedbackReasonCard.vue";
import OnboardingDialog from "@/components/OnboardingDialog.vue";
import {trackEvent}  from "../lib/flevents"
import { mapState } from "vuex";


const DAY_NAMES = [
  "Sunday","Monday", "Tuesday","Wednesday", "Thursday", "Friday","Saturday"
]
export default {
  name: "Dashboard",
  components: { StatsCard, FeedbackReasonCard },
  data: function () {
    return {
      stats: null,
      newsletterChart: null,
      newsletterPerformanceTable: null,
      showNewsletterPerformanceChart: true,
      recentFeedback: [],
      searchTerm: null,
      isLoading: false,
      dayMostUpVotes: "n/a",
      dayMostOkVotes: "n/a",
      dayMostDownVotes: "n/a",
      chartOptions: {
        axisX: {
          offset: 100
        },
        stackBars: true,
          plugins: [
            this.$chartist.plugins.tooltip({
              anchorToPoint:false,
              appendToBody: true
            })
          ]
        },
        recentFeedbackLimit: localStorage.getItem("recentFeedbackLimit") || 50,
    };
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }

    if( this.isOnboarding) {

      this.$buefy.modal.open({
        parent: this,
        component: OnboardingDialog,
        canCancel: false,
        width: 640,
        trapFocus: true,
        hasModalCard: true,
      })

    } else {
      if (this.userLoaded === true) {
        this.isLoading = true
        this.load().then((response) => {
          this.loadChart();
          this.loadRecentFeedback();
        });
      }

      trackEvent(this.$store.state.user.id, "dashboard-view")
    }

    
    /*
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', '/feedback/widget/03e53404-0a38-44b0-8998-7ef8bfbaa197/left')
    externalScript.setAttribute('defer',"")
    document.head.appendChild(externalScript)
    */
 
  },
  watch: {
    userLoaded: function (val) {
      if (val === true) {
        console.log("user loaded")
        this.isLoading = true
        this.load().then((response) => {
          this.loadChart();
          this.loadRecentFeedback();
        });
      }
    }
  },
  computed: {
    isOnboarding() {
      return this.$route.meta.onboarding === true
    },
    subscribed() {
      return this.account.subscribed;
    },
    ...mapState(["user", "account","userLoaded"]),

    statsLabels() {
      if (this.stats) {
        let labels = {
          votesUp: this.stats.all_time_totals.up_label,
          votesOk: this.stats.all_time_totals.ok_label,
          votesDown: this.stats.all_time_totals.down_label,
        }
        return labels
      }
    },
    hasStats() {
      let total = this.stats.all_time_totals.up_votes + this.stats.all_time_totals.ok_votes + this.stats.all_time_totals.down_votes +
      this.stats.all_time_totals.option4_votes + this.stats.all_time_totals.option5_votes

      return total != 0
    }
  },
  methods: {
    feedbackDeleted: function (feedbackId) {
      this.recentFeedback.splice(this.recentFeedback.findIndex(v => v.id === feedbackId), 1)
    },
    loadRecentFeedback: async function (limit) {
      var self = this;
      if (limit !== undefined) {
        this.recentFeedbackLimit = limit
        localStorage.setItem("recentFeedbackLimit", this.recentFeedbackLimit)
      }
      //console.log(url)
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          let loadingComponent = this.$buefy.loading.open({
            container: self.$refs.recentFeedbackLoading
          })
          atomic(self.apiHost + `account/${this.account.id}/feedback/recent?l=${this.recentFeedbackLimit}`, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.user.app_metadata.api_token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              
              self.recentFeedback = response.data;
              loadingComponent.close()
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    exportPerformanceReport: async function () {
      var self = this;

      this.trackPageView("performance-export")

      var url = self.apiHost + `account/${this.account.id}/report/newsletter-performance/csv`;
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          let loadingComponent = this.$buefy.loading.open({
            container: this.$refs.statsLoading
          })
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.user.app_metadata.api_token,
              responseType: 'blob',
            },
          })
            .then(function (response) {
              var a = document.createElement("a");
              a.href = window.URL.createObjectURL(new Blob([response.data], {type : 'application/csv'}));
              a.download = "feedletter-performance-export.csv";
              a.click();
              
              loadingComponent.close()
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        });
    },
    exportFeedback: async function () {
      var self = this;

      this.trackPageView("feedback-export")

      var url = self.apiHost + `account/${this.account.id}/feedback/csv`;
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          let loadingComponent = this.$buefy.loading.open({
            container: this.$refs.statsLoading
          })
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.user.app_metadata.api_token,
              responseType: 'blob',
            },
          })
            .then(function (response) {
              var a = document.createElement("a");
              a.href = window.URL.createObjectURL(new Blob([response.data], {type : 'application/csv'}));
              a.download = "feedletter-feedback-export.csv";
              a.click();
              
              loadingComponent.close()
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        });
    },
    load: async function () {
      var self = this;

      var url = self.apiHost + `account/${this.account.id}/dashboard/stats`;
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          let loadingComponent = this.$buefy.loading.open({
            container: this.$refs.statsLoading
          })
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.user.app_metadata.api_token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              let stats = response.data

              let winnerUp = {index: 0, value: 0}
              let winnerOk = {index: 0, value: 0}
              let winnerDown = {index: 0, value: 0}
              if (stats.weekday_stats !== undefined) {
                for (let index = 0; index < stats.weekday_stats.length; index++) {
                  const day = stats.weekday_stats[index];
                  if( day.up_votes > winnerUp.value) {
                    winnerUp.index = day.weekday
                    winnerUp.value = day.up_votes
                  }
                  if( day.ok_votes > winnerOk.value) {
                    winnerOk.index = day.weekday
                    winnerOk.value = day.ok_votes
                  }
                  if( day.down_votes > winnerDown.value) {
                    winnerDown.index = day.weekday
                    winnerDown.value = day.down_votes
                  }
                }

                if(winnerUp.value > 0) {
                  self.dayMostUpVotes = DAY_NAMES[winnerUp.index]
                }
                if(winnerOk.value > 0) {
                  self.dayMostOkVotes = DAY_NAMES[winnerOk.index]
                }
                if(winnerDown.value > 0) {
                  self.dayMostDownVotes = DAY_NAMES[winnerDown.index]
                }  
              }

              self.stats = stats;
              
              loadingComponent.close()
              return true
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        });
    },

    loadChart: async function () {
      var self = this;

      var url = self.apiHost + `account/${this.account.id}/dashboard/chart`;
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          let loadingComponent = this.$buefy.loading.open({
            container: this.$refs.statsLoading
          })
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.user.app_metadata.api_token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              let forms = response.data

              if( forms !== undefined && forms.length >0) {
                var labels = []
                var ups = []
                var oks = []
                var downs = []
                
                var tableRows = []
                var tableHeaders = []


                for (var i = forms.length -1 ; i >= 0; i--) {
                  // for chart
                  labels.push(forms[i].name)
                  ups.push({meta: forms[i].name + " " + forms[i].up_label, value: forms[i].up_votes})
                  oks.push({meta: forms[i].name + " " + forms[i].ok_label, value: forms[i].ok_votes})
                  downs.push({meta: forms[i].name + " " + forms[i].down_label, value: forms[i].down_votes})

                  // for table
                  if(tableRows.length === 0) {
                    tableHeaders.push(forms[i].up_label)
                    tableHeaders.push(forms[i].ok_label)
                    tableHeaders.push(forms[i].down_label)
                  }
                  let row = []
                  row.push(forms[i].name)
                  row.push(forms[i].up_votes)
                  row.push(forms[i].ok_votes)
                  row.push(forms[i].down_votes)
                  tableRows.push(row)
                }

                if (forms.length < 20) {
                  for (var i = 20 - forms.length ; i >= 0; i--) {
                    labels.push("")
                    ups.push({meta: "", value: 0})
                    oks.push({meta: "", value: 0})
                    downs.push({meta: "", value: 0})
                  }
                }

                var data = {
                  // A labels array that can contain any sort of values
                  labels: labels,
                  // Our series array that contains series objects or in this case series data arrays
                  series: [
                    ups, oks, downs
                  ]
                };
                self.newsletterChart = data;
                
                var tableData = {
                  labels: labels,
                  rows: tableRows,
                  headers: tableHeaders
                }
                self.newsletterPerformanceTable = tableData
              }


              
              loadingComponent.close()
              self.isLoading = false
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        });
    },
  },
};
</script>

<style scoped>

</style>